import { render, staticRenderFns } from "./PremiumConceptDesc.vue?vue&type=template&id=6fcd7e96&scoped=true"
import script from "./PremiumConceptDesc.vue?vue&type=script&lang=js"
export * from "./PremiumConceptDesc.vue?vue&type=script&lang=js"
import style0 from "../../../../../shared/concept-story.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./PremiumConceptDesc.vue?vue&type=style&index=1&id=6fcd7e96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../컨셉펀딩/worktrees/yesandlegeyo-copy-test-20260921/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcd7e96",
  null
  
)

export default component.exports